module.exports = __webpack_public_path__ + "static/media/borana.c34d4ece.png";